import React, { Component } from 'react'
import classes from './Register.module.css'
import Image from '../../Assests/Image/Register.png'
import axios from 'axios'
import Image2 from '../../Assests/Image/illlustration2.png'
import Image3 from '../../Assests/Image/illlustration4.png'
import SimpleReactValidator from 'simple-react-validator';
import { connect } from 'react-redux';
import {Modal} from 'antd'
import CircularProgress from '@material-ui/core/CircularProgress';
import Slider from 'infinite-react-carousel';
import { Alert } from 'antd';
import Backdrop from '../../Components/Backdrop/Backdrop'
import SelectSearch from 'react-select-search';
import * as action from '../../Store/Action/index';


class Register extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({
            element: (message, className) => <div className={classes.validation}>{message}</div>
        });
    }

    state = {
        allValid: true,
        College: [],
        Year: [],
        Semester: [],
        Courses: [],
        serverResponseError:'',
        Stream: [],
        registerData: {
            university_id: "",
            college_id: "",
            year_id: "",
            course_id: "",
            stream_id: "",
            semester_id: "",
            full_name: "",
            mobile: "",
            email: "",
            password: "",
            device_type: 1
        },
        succesMessage:'',
        error:false,
        success:false,
        loading:false,
        formInvalid: true,
        selectedStream: {},
        selectedYear: {}
    }

    componentDidMount() {
      this.props.onGetAcademicDetails();
    }

    toHome = ()=>{
        this.props.history.push("/")
    }

    ClickHandler = () => {
      console.log('submitting');
      console.log(this.state.registerData);
      this.props.onRegister(this.state.registerData);
    }

    onSelectHandler = (identifier, e) => {

      /* Form validation. */
      let formInvalid = this.state.formInvalid
      if (this.validator.allValid()) {
          formInvalid = false
      } else {
          formInvalid = true
          this.validator.showMessages();
      }

      if (identifier == "university_id") {
          let newData = { ...this.state.registerData }
          newData["college_id"] = ""
          newData["course_id"] = ""
          newData["stream_id"] = ""
          newData["year_id"] = ""
          newData["semester_id"] = ""
          if (this.state.registerData.university_id == -1 || e.target.value == -1) {
            newData["university_id"] = "";
          } else {
            newData["university_id"] = e.target.value;
            this.props.getCollegeDetails(e.target.value);
          }
        this.setState({ 
          registerData: newData, 
          formInvalid: formInvalid
        });
      }
      else if (identifier == "college_id") {
        let newData = { ...this.state.registerData }
        newData["course_id"] = ""
        newData["stream_id"] = ""
        newData["year_id"] = ""
        newData["semester_id"] = ""
        if (this.state.registerData.college_id == -1 || e.target.value == -1) {
          newData["college_id"] = ""
        } else {
          newData["college_id"] = e.target.value;
          this.props.getCourseDetails(this.state.registerData.university_id, e.target.value);
        }
        this.setState({
          registerData: newData,
          formInvalid: formInvalid
        });
      }
      else if (identifier == "course_id") {
        let newData = { ...this.state.registerData }
        newData["stream_id"] = "";
        newData["year_id"] = "";
        newData["semester_id"] = "";
        if (this.state.registerData.course_id == -1 || e.target.value == -1) {
          newData["course_id"] = "";
        } else {
          newData["course_id"] = e.target.value;
          this.props.getStreamDetails(this.state.registerData.university_id, e.target.value);
        }
        this.setState({
          registerData: newData,
          formInvalid: formInvalid
        })
      }
      else if (identifier == "stream_id") {
        let newData = { ...this.state.registerData }
        let selectedStream = this.props.streamDetails;
        let i = -1;
        newData["year_id"] = ""
        newData["semester_id"] = ""
        console.log(e.target.value);
        if (this.state.registerData.stream_id == -1 || e.target.value == -1) {
          console.log('here');
          newData["stream_id"] = "";
          selectedStream = {};
        } else {
          newData["stream_id"] = e.target.value;

          /* Get current stream details. */
          selectedStream.forEach((val, index) => {
            if(parseInt(val.stream_id) == parseInt(e.target.value)) {
              i = index;
              return;
            }
          });
          console.log(i);
          selectedStream = this.props.streamDetails[i];
        }
        console.log(newData);
        this.setState({
          registerData: newData,
          formInvalid: formInvalid,
          selectedStream 
        })
      }
      else if (identifier == "year_id") {
        let newData = { ...this.state.registerData }
        let selectedYear = this.state.selectedStream.years;
        let i = -1;
        newData["semester_id"] = ""
        if (this.state.registerData.year_id == -1 || e.target.value == -1) {
          newData["year_id"] = ""
          selectedYear = {};
        } else {
          newData["year_id"] = e.target.value;

          /* Get current year details. */
          selectedYear.forEach((val, index) => {
            if(parseInt(val.year_id) == parseInt(e.target.value)) {
              i = index;
              return;
            }
          });
          console.log(i);
          selectedYear = this.state.selectedStream.years[i];
        }
        this.setState({
          registerData: newData,
          formInvalid: formInvalid,
          selectedYear
        });
      }
      else {
        let newData = { ...this.state.registerData }
        newData[identifier] = e.target.value;
        this.setState({
          registerData: newData,
          formInvalid: formInvalid
        });
      }
    }

    render() {
        let message = null
        if (this.props.registrationError && this.props.registrationError.error) {
          //message = <Alert message={this.state.serverResponseError} type="error" />
          message = <Alert message={this.props.registrationError.error} type="error" />
        }
        else if (this.props.registrationError && this.props.registrationError.msg) {
          //message = <Alert message={this.state.serverResponseError} type="error" />
          message = <Alert message={this.props.registrationError.msg} type="error" />
        }
        else if(this.props.registrationSuccess && this.props.registrationSuccess.msg)
        {
          message=  <Alert message={this.props.registrationSuccess.msg} type="success" />
        }
        let form = (
          <div className={classes.registerForm}>
            <input className={classes.input} 
                   placeholder="Full Name" 
                   onChange={(event) => this.onSelectHandler("full_name", event)} /> 
            {this.validator.message('Full Name', this.state.registerData.full_name, 'required|alpha')}

            <input className={classes.input} 
                   placeholder="Phone Number" 
                   onChange={(event) => this.onSelectHandler("mobile", event)} />
            {this.validator.message("Mobile", this.state.registerData.mobile, 'required|Number')}

            <input className={classes.input} 
                   placeholder="Email"
                   onChange={(event) => this.onSelectHandler("email", event)} />
            {this.validator.message('Email', this.state.registerData.email, 'required|email')}

            <input className={classes.input}
                   type="password" 
                   placeholder="Password"
                   onChange={(event) => this.onSelectHandler("password", event)} />
            {this.validator.message('Password', this.state.registerData.password, 'required|min:8')}

            <select className={classes.selectbig} 
                    placeholder="Select University" 
                    onChange={(event) => this.onSelectHandler("university_id", event)}>

                <option value={-1} selected="selected">Select University</option>
                { 
                  this.props.academicDetails.map((element, index) =>
                    <option value={element.id}>{element.university_name}</option>
                  )
                }
            </select>

            <div className={classes.selectCont}>
                <select className={classes.select} 
                        disabled={!this.state.registerData.university_id}
                        onChange={(event) => this.onSelectHandler("college_id", event)}>

                    <option value={-1} selected="selected">Select College</option>
                    { this.state.registerData.university_id && 
                      this.props.collegeDetails.map((element, index) =>
                        <option value={element.id}>{element.college_name}</option>
                       )
                    }
                </select>
           
                <select className={classes.select}
                        disabled={!this.state.registerData.college_id}
                        onChange={(event) => this.onSelectHandler("course_id", event)}>

                    <option value={-1} selected="selected">Select Courses</option>
                    { this.state.registerData.college_id && 
                      this.props.courseDetails.map((element, index) =>
                        <option value={element.id}>{element.title}</option>
                      )
                    }
                </select>
            </div>

            <div className={classes.selectCont}>
                <select className={classes.select}
                        disabled={!this.state.registerData.course_id}
                        onChange={(event) => this.onSelectHandler("stream_id", event)}>

                    <option value={-1} selected="selected">Select Stream</option>
                    { this.state.registerData.course_id && 
                      this.props.streamDetails.map((element, index) =>
                        //<option value={element.stream_id}>{element.stream_title}</option>
                        <option value={element.stream_id}>{element.stream_title}</option>
                      )
                    }
                </select>
                   
                <select className={classes.select}
                        disabled={!this.state.registerData.stream_id}
                        onChange={(event) => this.onSelectHandler("year_id", event)}>

                    <option value={-1} selected="selected">Select Year</option>
                    { this.state.registerData.stream_id &&
                      this.state.selectedStream.years.map((element, index) =>
                       <option value={element.year_id}>{element.year_title}</option>
                      )
                    }
                </select>
  
            </div>
            <select className={classes.select}
                    disabled={!this.state.registerData.year_id}
                    onChange={(event) => this.onSelectHandler("semester_id", event)}>

                <option value={-1} selected="selected">Select Semester</option>
                { 
                  this.state.registerData.year_id && 
                  this.state.selectedYear.semesters.map((element, index) =>
                   <option value={element.id}>{element.title}</option>
                  )
                }
            </select>
            <center><button onClick={this.ClickHandler} className={classes.btn}>Register</button></center>
          </div>
        )
        if(this.props.registerLoading) {
            form = (
                  <div className={classes.loading}>
                    <h1>loading</h1>
                    <CircularProgress />
                  </div>
            )
        }
       
        return (
            <div className={classes.registerCont}>
              <div className={classes.form}>
                <div className = {classes.toHome} onClick = {this.toHome}>
                  <img src="https://test-server.glossaread.com/webroot/css/front_end/new_design/images/glossaread_logo_wht.svg"/>
                </div>
                <p className={classes.formHeading}>
                    Create an Account
                </p>
                {message}
                {form}
              </div>
              <div className={classes.illusCont}>
                <center>
                  <Slider arrows={false} dots autoplay>
                    <div className={classes.illus}>
                      <img  className = {classes.img}src={Image} alt="ilustration"></img>
                    </div>
                    <div className={classes.illus2}>
                      <img  className = {classes.img2}src={Image2} alt="ilustration"></img>
                    </div>
                    <div className={classes.illus}>
                      <img  className = {classes.img}src={Image3} alt="ilustration"></img>
                    </div>
                  </Slider>
                  <p className={classes.heading}>One of Us?</p>
                  <p className={classes.content}>
                    If you already have an account, just login
                  </p>
                  <button onClick={() => this.props.history.push('/login')} className={classes.btn2}>Login</button>
                </center>
              </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    register: state.register.registering,
    academicDetails: state.academic.academicDetails,
    collegeDetails: state.academic.collegeDetails,
    courseDetails: state.academic.courseDetails,
    streamDetails: state.academic.streamDetails,
    yearDetails: state.academic.yearDetails,
    registrationError: state.register.error,
    registrationSuccess: state.register.success,
    registerLoading: state.register.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onRegister: (user) => dispatch(action.register(user)),
    onGetAcademicDetails: () => dispatch(action.getAcademicDetails()),
    getCollegeDetails: (university_id) => dispatch(action.getCollegeDetails(university_id)),
    getCourseDetails: (university_id, college_id) => dispatch(action.getCourseDetails(university_id, college_id)),
    getStreamDetails: (university_id, course_id) => dispatch(action.getStreamDetails(university_id, course_id)),
    getYearAndSemesterDetails: (course_id) => dispatch(action.getYearAndSemesterDetails()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);
